import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import Edit from "../../assets/Edit";
import Delete from "../../assets/Delete";
import columns from "../../columns/banner/column";
import SkeletonTable from "../../components/table/SkeletonTable";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import { DeleteBannerApi, GetAllBannerListApi } from "../../api/request/banner";
import AddBanner from "./components/AddBanner";
import { Image } from "antd";

const Banners = () => {
  const [templateList, setTemplateList] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("view");
  const [selectedBanner, setSelectedBanner] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getTemplateList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetAllBannerListApi();
      if (data?.status) {
        setTemplateList(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <div
                  className={`${
                    item?.status == "active" ? "text-green-500" : "text-red-500"
                  } font-semibold uppercase`}
                >
                  {item?.status}
                </div>
              ),
              image: (
                <div className="flex gap-3 items-center justify-start ">
                  <Image
                    height={100}
                    width={200}
                    preview={{
                      src: item?.image,
                    }}
                    src={item?.image}
                    className="object-contain"
                  />
                </div>
              ),
              created_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              action: (
                <div className="flex items-center gap-5">
                  <button
                    onClick={() => {
                      setSelectedBanner(item);
                      setMode("edit");
                      setIsModalOpen(true);
                    }}
                  >
                    <Edit />
                  </button>
                  <button
                    onClick={() => {
                      setSelectedBanner(item);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <Delete />
                  </button>
                </div>
              ),
            };
          })
        );
      }
      setTotal(data?.total_record);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTemplateList();
  }, []);

  const deleteBanner = async () => {
    try {
      setIsDeleteLoading(true);
      const { data } = await DeleteBannerApi({
        id: selectedBanner?.id,
      });
      if (data.status) {
        setIsDeleteLoading(false);
        setIsDeleteModalOpen(false);
        toast.success(data.message);
        setSelectedBanner({});
        getTemplateList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsDeleteLoading(false);
    }
  };

  return (
    <div>
      <div className="border rounded-lg bg-White pb-5">
        <div className="flex items-center justify-between p-5">
          <p className="font-semibold text-2xl">
            Banners {total ? `(${total})` : null}
          </p>
          <div className="flex gap-2 items-center">
            <AddBanner
              selectedBanner={selectedBanner}
              getTemplateList={getTemplateList}
              setSelectedBanner={setSelectedBanner}
              setMode={setMode}
              mode={mode}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
          </div>
        </div>

        <SkeletonTable
          columns={columns}
          searchingFields={["name"]}
          data={templateList}
          isLoading={isLoading}
        />
      </div>

      {/* --- Delete confirmation modal --- */}
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        message={`Are you sure you want to delete this banner template?`}
        onConfirm={deleteBanner}
        isLoading={isDeleteLoading}
        loadingLabel={`Deleting banner...`}
      />
    </div>
  );
};

export default Banners;
